import React from 'react'
import loadable from '@loadable/component'
import usePostHook from '../../customHooks/usePostHook'
import APIS from '../../contants/Endpoints'
import { toast } from 'react-toastify'
const AddCustomerComponent = loadable(() => import('../../components/Customer/AddCustomer'))
type Props = {}

const AddCustomer = (props: Props) => {
  const { isPostLoading, mutateAsync, postData } = usePostHook({ queryKey: ["customer"], navigateURL: "/customer" });

  const handleAddCustomer = async (values: any, setError: any) => {
    const url = APIS.CUSTOMER;
    const formData = {
      name: values.title,
      address: values.address,
      contact_number: values?.contact_number,
      email: values?.email
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err: any) {
      console.error("Error creating customer:", err?.res);
    }
  };

  return (
    <AddCustomerComponent handleAddCustomer={handleAddCustomer} />
  )
}

export default AddCustomer